import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';

const COLS = ['ID', 'Descrição', 'Sigla', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

export default function ListaUnidade() {
  const [search, setSearch]   = useState('');
  const [perPage, setPerPage] = useState(25);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = (q = search, pp = perPage) => {
    setLoading(true);
    axios.get(
      `${Apis.urlListarUnidades}?pesquisa=${q}&qtd_registros=${pp}`,
      { headers: headers() }
    )
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(search, val); };

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Unidades"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por descrição ou sigla…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      fab={{ show: true, label: 'unidade', path: 'cadastrar-unidade/0' }}
      emptyMessage="Nenhuma unidade encontrada."
    >
      {data.map((c, i) => (
        <tr key={c.id}
          style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
        >
          <TD>{c.id}</TD>
          <TD uppercase>{c.descricao}</TD>
          <TD>{c.sigla}</TD>
          <TD>
            <Actions>
              <EditBtn to={`/alterar-unidade/${c.id}`} />
              <DeleteBtn url={Apis.urlDeletarUnidades} id={c.id} redirect="listar-unidades" component="Unidade" texto={`Deseja realmente excluir a unidade ${c.descricao}`} />
            </Actions>
          </TD>
        </tr>
      ))}
    </TableLayout>
  );
}
